<div class="flex width-100% gap-x-md justify-end">
  <ng-content></ng-content>
</div>
